import { render } from 'preact';
import { installTelemetry } from './lib/telemetry.js';
import { App } from './App.js';
import './styles.css';

installTelemetry();

const root = document.getElementById('app');
if (root) render(<App />, root);
